export default {
  title: 'Regione',
  NAOnlyMessage: 'Imposta il prefisso. Verrà usato per le chiamate locali.',
  MultiWithNAMessage: 'Imposta i prefissi locale e internazionale. Verranno utilizzati per la formattazione dei numeri di telefono e le chiamate locali.',
  MultiWithoutNAMessage: 'Seleziona il paese in cui ti trovi. Verrà utilizzato per la formattazione dei numeri di telefono e le chiamate locali.',
  country: 'Paese',
  areaCode: 'Prefisso',
  areaCodePlaceholder: 'Inserisci prefisso',
};
